import { Component, OnInit } from '@angular/core';
declare var jQuery:any;
@Component({
selector: 'app-profile',
templateUrl: '../views/profile.component.html',
styleUrls: ['../css/profile.component.css']
})
export class ProfileComponent implements OnInit {

constructor() { }

ngOnInit() {
}



}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/profile.component.ts